module.exports = __webpack_public_path__ + "static/media/feature_business_intelligence.f63b16d6.png";